/** @jsxImportSource @emotion/react */
import AiRefCallTestPanel from 'pages/sample/AiRefCallTestPanel';

/** AI Server 통합 인터페이스(BE AiRefService) 호출 테스트 화면 */
const CallTestPage = () => {
  return <AiRefCallTestPanel />;
};
export default CallTestPage;
